/* __next_internal_client_entry_do_not_use__ ComponentDisplayOnHoverContainer auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useProductTileContainerRef } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileContainerRefContextProvider";
import { useContainerRef } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/useContainerRef";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
/**
 * This helper enable us to detect if user is hovering on image for the first time,
 * then the `hasHovered` became true and we can load those components, to avoid loading
 * all of them on initial load.
 * @returns
 */ var useHasHovered = function(containerRef) {
    var _useState = _sliced_to_array(useState(false), 2), hasHovered = _useState[0], setHasHovered = _useState[1];
    var refCurrent = useContainerRef(containerRef);
    useEffect(function() {
        var handleMouseEnter = function() {
            return setHasHovered(true);
        };
        if (refCurrent) {
            refCurrent.addEventListener("mouseenter", handleMouseEnter, {
                once: true
            });
            return function() {
                return refCurrent.removeEventListener("mouseenter", handleMouseEnter);
            };
        }
        return function() {};
    }, [
        refCurrent
    ]);
    return hasHovered;
};
export var ComponentDisplayOnHoverContainer = function(param) {
    var children = param.children;
    var isTabletAndAbove = useViewport().isTabletAndAbove;
    var _useState = _sliced_to_array(useState(false), 2), isHovering = _useState[0], setisHovering = _useState[1];
    var containerRef = useProductTileContainerRef();
    var hasHovered = useHasHovered(containerRef);
    var refCurrent = useContainerRef(containerRef);
    var handleMouseEnter = function() {
        return setisHovering(true);
    };
    var handleMouseLeave = function() {
        return setisHovering(false);
    };
    useEffect(function() {
        if (refCurrent && isTabletAndAbove) {
            refCurrent.addEventListener("mouseover", handleMouseEnter);
            refCurrent.addEventListener("mouseout", handleMouseLeave);
            return function() {
                refCurrent.removeEventListener("mouseover", handleMouseEnter);
                refCurrent.removeEventListener("mouseout", handleMouseLeave);
            };
        }
        return function() {};
    }, [
        isTabletAndAbove,
        refCurrent
    ]);
    if (!refCurrent || !hasHovered) {
        return null;
    }
    // TODO in the future we should not mount unless hovered, keeping as is to preserve existing functionality
    return /*#__PURE__*/ _jsx(VisibilityWrapper, {
        $isVisible: isHovering,
        children: children
    });
};
var VisibilityWrapper = styled.div.withConfig({
    componentId: "sc-ef680fc1-0"
})([
    "",
    ""
], function(param) {
    var $isVisible = param.$isVisible;
    return !$isVisible ? css([
        "display:none;"
    ]) : "";
});
